import React from "react";
import { Popconfirm } from "antd";
import { Spinner } from "../../../../UI";
import Container from "./style";

const Subscription = ({
  subscriptions,
  name,
  handleAltSubscriptionStatus,
  handleCancelSubscription,
  pauseSubLoading = [],
  cancelSubLoading = [],
}) => {
  return (
    <Container>
      <h1>Subscription</h1>
      <hr />
      <div className="subscription-lists">
        {subscriptions?.data && subscriptions.data.length > 0 ? (
          subscriptions.data.map(
            ({ plan, start_date, end_date, status, id }) => (
              <div className="sub-item" key={id}>
                <div className="profile-container">
                  <div className="img-container" />
                  <div>
                    <h3>
                      {plan.name}({plan.interval})
                    </h3>
                    <p>
                      {start_date} - {end_date}
                    </p>
                  </div>
                </div>
                <div className="status-container">
                  <span
                    style={{
                      color:
                        status === "paused"
                          ? "#d48806"
                          : status === "active"
                            ? "green"
                            : "red",
                    }}
                  >
                    {status}
                  </span>
                  {status !== "expired" && status !== "cancelled" && (
                    <div className="btn-group">
                      {pauseSubLoading.includes(id) ? (
                        <Spinner />
                      ) : (
                        <button
                          type="button"
                          className={`${
                            status === "active" ? "pause-btn" : "resume-btn"
                          }`}
                          onClick={() => handleAltSubscriptionStatus(id, status)}
                        >
                          {status === "active" ? "Pause" : "Resume"}
                        </button>
                      )}
                      {cancelSubLoading.includes(id) ? (
                        <Spinner />
                      ) : (
                        <Popconfirm
                          title="Are you sure you want to cancel this plan?"
                          onConfirm={() =>
                            typeof handleCancelSubscription === "function" &&
                            handleCancelSubscription(id)
                          }
                          okText="Yes, Cancel"
                          cancelText="No"
                          placement="topRight"
                        >
                          <button type="button" className="cancel-btn">
                            Cancel
                          </button>
                        </Popconfirm>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )
          )
        ) : (
          <h1 className="empty-placeholder">
            {name} don't have any subscription for now
          </h1>
        )}
      </div>
    </Container>
  );
};

export default Subscription;
